import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Institution } from 'domain/entities/representative'
import {
  representativeState,
  selectedRepresentativeInstitution,
} from 'presentation/redux/slices/representativeSlice'
import useSessionStorage from 'presentation/hooks/useSessionStorage'
import { selectedInstitutionKey } from 'presentation/constant/localStorageKeys'

export const useSaveInstitutionInSessionStorage = () => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(representativeState)
  const { saveDataAtSessionStorage } = useSessionStorage(selectedInstitutionKey)

  const saveInstitutionInSessionStorage = useCallback(
    (institution: Institution) => {
      saveDataAtSessionStorage({ data: institution })
      dispatch(selectedRepresentativeInstitution(institution))
    },
    [dispatch, saveDataAtSessionStorage],
  )

  return { saveInstitutionInSessionStorage, isLoading, error }
}
